import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react-lite';

import { useHandleOtpRefreshCodeErrors, useRefreshCode } from '@entities/otp';

import { CheckboxController, useStores } from '@shared/index';
import { FullWidthPrimaryButton } from '@shared/ui';

import {
  type StandardsAgreementProps,
  standardsAgreementSchema,
} from '../model';

interface Props {
  onSuccessSubmit: () => void;
}

export const StandardAgreement = observer(({ onSuccessSubmit }: Props) => {
  const { t } = useTranslation('STANDARDS');
  const {
    MainStore: {
      agentUserStore: { agent, setConfirmToken },
    },
  } = useStores();

  const { refetch, error, resetQueryErrorRefreshCode } = useRefreshCode({
    phone: agent?.phone || '',
    deps: [agent?.phone],
  });

  const methods = useForm<StandardsAgreementProps>({
    resolver: yupResolver(standardsAgreementSchema),
    mode: 'onBlur',
    shouldFocusError: true,
    defaultValues: {
      standardsAgreement: false,
    },
  });

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = methods;

  const handleFormSubmit = handleSubmit(() => {
    refetch().then(({ data }) => {
      if (data?.data?.token) {
        setConfirmToken(data.data.token);
        onSuccessSubmit();
      }
    });
  });

  useHandleOtpRefreshCodeErrors({
    error,
    resetQueryErrorRefreshCode,
  });

  return (
    <>
      <CheckboxController
        control={control}
        name='standardsAgreement'
        id='standardsAgreement'
        label={t('labels.standardAgreement')}
      />
      <FullWidthPrimaryButton
        size='l'
        onClick={handleFormSubmit}
        disabled={!!Object.keys(errors)?.length}
      >
        {t('buttons.confirm')}
      </FullWidthPrimaryButton>
    </>
  );
});
